import React, { useState } from "react";
import { TextHeader } from "components/Texts";

import Row from "components/Row";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Button from "components/Buttons";
import LoginModal from "components/facebook/LoginModal";

const Setup = () => {
  const { REACT_APP_GOOGLE_ADS_SETUP_MANUAL_URL } = process.env;

  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();

  const [modalLoginFacebookDisplay, setModalLoginFacebookDisplay] = useState("hide");

  const handleLoginFacebookModal = () => {
    setModalLoginFacebookDisplay("show");
  };

  const view = () => {
    return (
      <StyledContainer>
        <SetupWrapperHeader>
          <SetupTextHeader>{t("__fbads_setup_title")}</SetupTextHeader>
          <StyledManualLink>
            <StyledLink target="_blank" href={REACT_APP_GOOGLE_ADS_SETUP_MANUAL_URL}>
              <HelpIcon src="/images/help_outline.svg" />
              {t("__ads_setup_manual_link")}
            </StyledLink>
          </StyledManualLink>
        </SetupWrapperHeader>

        <SetupMainContainer>
          <SetupMainSubContainer>
            <Button onClick={handleLoginFacebookModal}>{t("__fbads_setup_setting_button")}</Button>
          </SetupMainSubContainer>
        </SetupMainContainer>

        <LoginModal show={modalLoginFacebookDisplay} setShow={setModalLoginFacebookDisplay} />
      </StyledContainer>
    );
  };

  return view();
};

export default Setup;

const SetupMainSubContainer = styled.div`
  text-align: center;
  line-height: 2.5em;
`;

const SetupMainContainer = styled.div`
  display: flex;
  background-color: #fbfeff;
  border-radius: 10px;
  border: 1px solid #f5f9fc;
  padding: 20px 5px;
  justify-content: center;
  align-item: center;
`;

const SetupWrapperHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SetupFacebookTitle = styled.div`
  font-size: 1rem;
  margin-bottom: 10px;
`;

const SetupTextHeader = styled(TextHeader)`
  font-size: 18px;
  margin-bottom: 10px;
`;

const StyledManualLink = styled.div`
  text-align: right;
  margin-bottom: 10px;
`;

const StyledLink = styled.a`
  text-decoration: none;
  color: #337ab7;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  width: fit-content;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledContainer = styled.div`
  font-size: 14px;
  color: #555;
  position: relative;

  .m-b-10 {
    margin-bottom: 10px;
  }

  @media screen and (max-width: 834px) {
    .links-container {
      display: flex;
      justify-content: center;
    }
  }
`;

const ModalContentContainer = styled.div`
  text-align: center;
  margin-bottom: 20px;
  color: #575757;
  font-weight: bold;

  .info-icon {
    font-size: 78px;
    color: #f8bb86;
    margin-bottom: 20px;
    font-weight: normal;
  }
`;

const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 16px;

  > Button {
    min-width: 100px;
    margin-bottom: 0px;
  }

  > Button:first-child {
    margin-right: 10px;
  }
`;

const HelpIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 6px;
`;
